#import "../fragments/slackChannel-basic.graphql"

query SlackChannelsQuery {
    slackChannels {
        ...SlackChannelBasic
    }
}
